import React from "react"
import HiddenField from "./hidden-field"

export default function HiddenFields({ formGuid, currentPageLink, langauge, formSubmissionId }) {
  return (
    <>
      <HiddenField name="__FormGuid" predefinedValue={formGuid} />
      <HiddenField name="__FormHostedPage" predefinedValue={currentPageLink} />
      <HiddenField name="__FormLanguage" predefinedValue={langauge} />
      <HiddenField name="__FormSubmissionId" predefinedValue={formSubmissionId} />
    </>
  )
}
